import { createAction } from '@reduxjs/toolkit';
import { PhotoScan } from '../../entities';

export const updateScan = createAction<PhotoScan>('scan/UPDATE_SCAN');
